import { render, staticRenderFns } from "./StickieContent.vue?vue&type=template&id=e0c4ae7e&scoped=true&"
import script from "./StickieContent.vue?vue&type=script&lang=js&"
export * from "./StickieContent.vue?vue&type=script&lang=js&"
import style0 from "./StickieContent.vue?vue&type=style&index=0&id=e0c4ae7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0c4ae7e",
  null
  
)

export default component.exports